// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"565":"subscriptions-packs","1720":"faq","4119":"store","9019":"header","9348":"footer","9697":"news"}[chunkId] || chunkId) + ".client-script.css";
};